module.exports = "<!--Notification-->\r\n<pcg-ng-notification></pcg-ng-notification>\r\n"